import styled, { css, keyframes } from 'styled-components';

const swipeAnimation = keyframes`
 0% { opacity: 0; }
 2% { opacity: 1; }
 48% { opacity: 1; }
 50% { opacity: 0; }
 100% { opacity: 0; }
`;

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  font-family: 'LaLigaESSports', system-ui;
  font-size: 44px;
  position: relative;
`;
Container.displayName = 'Container';

export const ColorsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 90px;
  width: 10px;
`;
ColorsContainer.displayName = 'ColorsContainer';

export const ColorsItem = styled.div`
  flex-grow: 1;
`;
ColorsItem.displayName = 'ColorsItem';

export const Logo = styled.img`
  height: 56px;
  margin-right: 8px;
`;
Logo.displayName = 'Logo';

export const LogoContainer = styled.div`
  align-items: center;
  background: #ff4b44;
  display: flex;
  height: 90px;
  justify-content: center;
  width: 150px;
`;
LogoContainer.displayName = 'LogoContainer';

export const Points = styled.div`
  color: #000000;
  font-size: 74px;
  font-weight: bold;
`;
Points.displayName = 'Points';

export const PointsContainer = styled.div`
  align-items: center;
  background-color: #eeeeee;
  color: #d0fb0c;
  display: flex;
  font-weight: bold;
  height: 90px;
  justify-content: center;
  min-width: 110px;
  padding: 0 16px;
  text-align: center;
`;
PointsContainer.displayName = 'PointsContainer';

export const Row = styled.div`
  align-items: center;
  display: flex;
`;
Row.displayName = 'Row';

export const Space = styled.div`
  background: #000000;
  height: 2px;
  position: absolute;
  right: 5px;
  top: 89px;
  width: 100px;
`;
Space.displayName = 'Space';

export const TeamLogo = styled.img`
  height: 70px;
`;
TeamLogo.displayName = 'TeamLogo';

export const TeamName = styled.div`
  align-items: center;
  background: #030303;
  color: #ffffff;
  display: flex;
  font-size: 32px;
  height: 90px;
  justify-content: center;
  letter-spacing: -1px;
  min-width: 110px;
  padding: 0 16px;
  position: relative;

  ${({ $hasTeamImage }) =>
    $hasTeamImage &&
    css`
      & span {
        animation-name: ${swipeAnimation};
        animation-duration: 30s;
        animation-iteration-count: infinite;
        position: absolute;
      }

      & img {
        animation-name: ${swipeAnimation};
        animation-duration: 30s;
        animation-delay: 15s;
        animation-iteration-count: infinite;
        opacity: 0;
        position: absolute;
      }
    `}
`;
TeamName.displayName = 'TeamName';

export const TimerContainer = styled.div`
  align-items: center;
  background: #eeeeee;
  display: flex;
  height: 90px;
  justify-content: center;
  width: 150px;
`;
TimerContainer.displayName = 'TimerContainer';

export const Timer = styled.div`
  color: #000000;

  & span {
    font-family: 'Roboto', sans-serif;
  }
`;
Timer.displayName = 'Timer';
